import Vue from "vue";
import Router from "vue-router";
import store from "@/store";
import Login from "@/views/Login.vue";
import NotFound from "@/views/NotFound.vue";
import Home from "@/views/Home.vue";
import menuContent from "@/views/menuContent.vue";
import Statement from "@/views/Statement.vue";
import MapContainer from "@/components/haiya/MapContainer.vue";
// import Fengmap from "@/components/haiya/Fengmap.vue";


import lyfyjsd from "@/views/lyfyjsd.vue";
import yjfytzd from "@/views/yjfytzd.vue";
import zlfymxd from "@/views/zlfymxd.vue";
import fkqkd from "@/views/fkqkd.vue";
import xscx from "@/views/xscx.vue";
import ht from "@/views/ht.vue";
import print_fkqkd from "@/views/print_fkqkd.vue";
import print_kpqrd from "@/views/print_kpqrd.vue";
import print_yjftzd from "@/views/print_yjftzd.vue";
import print_lyfyjsd from "@/views/print_lyfyjsd.vue";
import print_zlfymxd from "@/views/print_zlfymxd.vue";
import print_zlfymxd_all from "@/views/print_zlfymxd_all.vue";
import print_lyfyjsd_all from "@/views/print_lyfyjsd_all.vue";
import print_yjftzd_all from "@/views/print_yjftzd_all.vue";

import shcjftzd from "@/views/shcjftzd.vue";
import print_shcjftzd from "@/views/print_shcjftzd.vue";
import print_shcjftzd_all from "@/views/print_shcjftzd_all.vue";

Vue.use(Router);

var router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: {
        name: "home"
      }
    },
    {
      path: "/home/homeEmail",
      name: "homeEmail",
      component: () => import("@/components/home/homeEmail.vue"),
      props: true
    },
    {
      path: "/login/:tenant",
      name: "loginTenant",
      props: true,
      component: Login,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        single: true,
        anonymous: true
      }
    },


    {
      path: "/lyfyjsd",
      name: "lyfyjsd",
      component: lyfyjsd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/lyfyjsd/:tenant",
      name: "lyfyjsdTenant",
      props: true,
      component: lyfyjsd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/yjfytzd",
      name: "yjfytzd",
      component: yjfytzd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/yjfytzd/:tenant",
      name: "yjfytzdTenant",
      props: true,
      component: yjfytzd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/shcjftzd",
      name: "shcjftzd",
      component: shcjftzd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/shcjftzd/:tenant",
      name: "shcjftzdTenant",
      props: true,
      component: shcjftzd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_shcjftzd",
      name: "print_shcjftzd",
      component: print_shcjftzd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_shcjftzd/:tenant",
      name: "print_shcjftzdTenant",
      props: true,
      component: print_shcjftzd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_shcjftzd_all",
      name: "print_shcjftzd_all",
      component: print_shcjftzd_all,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_shcjftzd_all/:tenant",
      name: "print_shcjftzd_allTenant",
      props: true,
      component: print_shcjftzd_all,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/zlfymxd",
      name: "zlfymxd",
      component: zlfymxd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/zlfymxd/:tenant",
      name: "zlfymxdTenant",
      props: true,
      component: zlfymxd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/fkqkd",
      name: "fkqkd",
      component: fkqkd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/fkqkd/:tenant",
      name: "fkqkdTenant",
      props: true,
      component: fkqkd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/xscx",
      name: "xscx",
      component: xscx,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/xscx/:tenant",
      name: "xscxTenant",
      props: true,
      component: xscx,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/ht",
      name: "ht",
      component: ht,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/ht/:tenant",
      name: "htTenant",
      props: true,
      component: ht,
      meta: {
        single: true,
        anonymous: true
      }
    },

    {
      path: "/print_fkqkd",
      name: "print_fkqkd",
      component: print_fkqkd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_fkqkd/:tenant",
      name: "print_fkqkdTenant",
      props: true,
      component: print_fkqkd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_kpqrd",
      name: "print_kpqrd",
      component: print_kpqrd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_kpqrd/:tenant",
      name: "print_kpqrdTenant",
      props: true,
      component: print_kpqrd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_yjftzd",
      name: "print_yjftzd",
      component: print_yjftzd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_yjftzd/:tenant",
      name: "print_yjftzdTenant",
      props: true,
      component: print_yjftzd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_yjftzd_all",
      name: "print_yjftzd_all",
      component: print_yjftzd_all,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_yjftzd_all/:tenant",
      name: "print_yjftzd_allTenant",
      props: true,
      component: print_yjftzd_all,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_lyfyjsd",
      name: "print_lyfyjsd",
      component: print_lyfyjsd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_lyfyjsd/:tenant",
      name: "print_lyfyjsdTenant",
      props: true,
      component: print_lyfyjsd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_zlfymxd",
      name: "print_zlfymxd",
      component: print_zlfymxd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_zlfymxd/:tenant",
      name: "print_zlfymxdTenant",
      props: true,
      component: print_zlfymxd,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_zlfymxd_all",
      name: "print_zlfymxd_all",
      component: print_zlfymxd_all,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_zlfymxd_all/:tenant",
      name: "print_zlfymxd_allTenant",
      props: true,
      component: print_zlfymxd_all,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_lyfyjsd_all",
      name: "print_lyfyjsd_all",
      component: print_lyfyjsd_all,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/print_lyfyjsd_all/:tenant",
      name: "print_lyfyjsd_allTenant",
      props: true,
      component: print_lyfyjsd_all,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/mapContainer/:tenant",
      name: "mapContainerTenant",
      props: true,
      component: MapContainer,
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/mapContainer",
      name: "mapContainer",
      component: MapContainer,
      meta: {
        single: true,
        anonymous: true
      }
    },
    // {
    //   path: "/fengmap/:tenant",
    //   name: "fengmapTenant",
    //   props: true,
    //   component: Fengmap,
    //   meta: {
    //     single: true,
    //     anonymous: true
    //   }
    // },
    // {
    //   path: "/fengmap",
    //   name: "fengmap",
    //   component: Fengmap,
    //   meta: {
    //     single: true,
    //     anonymous: true
    //   }
    // },
    {
      path: "/resetPwdView",
      name: "resetPwdView",
      props: true,
      component: () => import("@/views/ResetPwdView.vue"),
      meta: {
        single: true,
        anonymous: true
      }
    },
    {
      path: "/formManage/:instId/:type",
      name: "formManage",
      component: () => import("@/components/flow/formManage.vue"),
      props: true,
      meta: {
        single: true
      }
    },
    {
      path: "/home",
      name: "home",
      component: Home
    },
    {
      path: "/v-flow",
      component: menuContent,
      children: [
        {
          path: "/",
          name: "haiyaTodo-default",
          redirect: "v-haiyaTodo"
        },
        {
          path: "v-todo",
          name: "todo",
          component: () => import("@/components/flow/todo.vue")
        },
        {
          path: "v-leader",
          name: "leader",
          component: () => import("@/components/flow/leaderTodo.vue")
        },

        {
          path: "v-todo/:defKey",
          name: "todo-defKey",
          component: () => import("@/components/flow/todo.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "v-contract",
          name: "contract",
          component: () => import("@/components/flow/contract.vue")
        },
        {
          path: "v-contract/:defKey",
          name: "contract-defKey",
          component: () => import("@/components/flow/contract.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "v-haiyaTodo",
          name: "haiyaTodo",
          component: () => import("@/components/flow/haiyaTodo.vue")
        },
        {
          path: "v-haiyaTodo/:defKey",
          name: "haiyaTodo-defKey",
          component: () => import("@/components/flow/haiyaTodo.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "v-haiyaDone",
          name: "haiyaDone",
          component: () => import("@/components/flow/haiyaDone.vue")
        },
        {
          path: "v-haiyaDone/:defKey",
          name: "haiyaDone-defKey",
          component: () => import("@/components/flow/haiyaDone.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "v-done",
          name: "done",
          component: () => import("@/components/flow/done.vue")
        },
        {
          path: "v-done/:defKey",
          name: "done-defKey",
          component: () => import("@/components/flow/done.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "v-request",
          name: "request",
          component: () => import("@/components/flow/myRequest.vue")
        },
        {
          path: "v-request/:defKey",
          name: "request-defKey",
          component: () => import("@/components/flow/myRequest.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "v-draft",
          name: "myDraft",
          component: () => import("@/components/flow/myDraft.vue"),
          props: true
        },
        {
          path: "v-flowList",
          name: "flowList",
          component: () => import("@/components/flow/flowList.vue")
        },
        {
          path: "v-todoRead",
          name: "todoRead",
          component: () => import("@/components/flow/todoRead.vue")
        },
        {
          path: "v-todoRead/:defKey",
          name: "todoRead-defKey",
          component: () => import("@/components/flow/todoRead.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "v-doneRead",
          name: "doneRead",
          component: () => import("@/components/flow/doneRead.vue")
        },
        {
          path: "v-doneRead/:defKey",
          name: "doneRead-defKey",
          component: () => import("@/components/flow/doneRead.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "v-myRead",
          name: "myRead",
          component: () => import("@/components/flow/myRead.vue")
        },
        {
          path: "v-myRead/:defKey",
          name: "myRead-defKey",
          component: () => import("@/components/flow/myRead.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "v-myDelegate",
          name: "myDelegate",
          component: () => import("@/components/flow/myDelegate.vue")
        },
        {
          path: "v-myDelegate/:defKey",
          name: "myDelegate-defKey",
          component: () => import("@/components/flow/myDelegate.vue"),
          props: true,
          meta: {
            single: true
          }
        }
      ]
    },
    {
      path: "/v-check",
      component: menuContent,
      children: [
        {
          path: "/",
          name: "haiyaCheck-default",
          redirect: "v-haiyaCheck"
        },
        {
          path: "v-haiyaCheck",
          name: "haiyaCheck",
          component: () => import("@/components/flow/haiyaCheck.vue")
        },
        {
          path: "v-haiyaCheck/:defKey",
          name: "haiyaCheck-defKey",
          component: () => import("@/components/flow/haiyaCheck.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "v-haiyaVacation",
          name: "haiyaVacation",
          component: () => import("@/components/flow/haiyaVacation.vue")
        },
        {
          path: "v-haiyaVacation/:defKey",
          name: "haiyaVacation-defKey",
          component: () => import("@/components/flow/haiyaVacation.vue"),
          props: true,
          meta: {
            single: true
          }
        },
      ]
    },
    {
      path: "/v-news",
      component: menuContent,
      children: [
        {
          path: "/",
          name: "haiyaNews-default",
          redirect: "v-haiyaNews"
        },
        {
          path: "v-haiyaNews",
          name: "haiyaNews",
          component: () => import("@/components/flow/haiyaNews.vue")
        },
        {
          path: "v-haiyaNews/:defKey",
          name: "haiyaNews-defKey",
          component: () => import("@/components/flow/haiyaNews.vue"),
          props: true,
          meta: {
            single: true
          }
        },
      ]
    },
    {
      path: "/v-haiyaMails",
      component: menuContent,
      children: [
        {
          path: "/",
          name: "haiyaMails-default",
          redirect: "v-haiyaMails"
        },
        {
          path: "v-haiyaMails",
          name: "haiyaMails",
          component: () => import("@/components/flow/haiyaMails.vue")
        },
        {
          path: "v-haiyaMails/:defKey",
          name: "haiyaMails-defKey",
          component: () => import("@/components/flow/haiyaMails.vue"),
          props: true,
          meta: {
            single: true
          }
        },
      ]
    },
    {
      path: "/vnewsList/:classifyId",
      name: "newsList",
      component: () => import("@/components/news/newsList.vue"),
      props: true
    },
    {
      path: "/v-todo/:orgName/:orgId",
      name: "todo",
      component: () => import("@/components/flow/todo.vue"),
      props: true
    },
    {
      path: "/editMap",
      name: "editMap",
      component: () => import("@/components/haiya/EditMap.vue"),
      props: false,
      meta: {
        single: true
      }
    },
    {
      path: "/editMapYy",
      name: "editMapYy",
      component: () => import("@/components/haiya/EditMapYy.vue"),
      props: false,
      meta: {
        single: true
      }
    },
    /* 跳转启动流程 */
    {
      path: "/agentStart/:defId/:leaderId",
      name: "defStart",
      component: () => import("@/components/flow/start.vue"),
      props: true
    },
    /**复制流程启动 */
    {
      path: "/agentStart/:defId/:leaderId/:copeInstId",
      name: "defStart",
      component: () => import("@/components/flow/start.vue"),
      props: true
    },
    //根据流程定义key启动流程
    {
      path: "/agentStartByKey/:defKey",
      name: "defKeyStart",
      component: () => import("@/components/flow/startByKey.vue"),
      props: true,
      meta: {
        single: true
      }
    },
    {
      path: "/sysModulePreview/:id",
      name: "sysModulePreview",
      component: () => import("@/components/generator/sysModulePreview.vue"),
      props: true,
      meta: {
        single: true
      }
    },
    {
      path: "/templateReport/:alias",
      name: "templateReport",
      component: () => import("@/components/dataTemplate/templateReport"),
      props: true,
      meta: {
        single: true
      }
    },
    {
      path: "/start/:defId/:instId",
      name: "instStart",
      component: () => import("@/components/flow/start.vue"),
      props: true
    },
    /* 跳转任务详情 */
    {
      path: "/inst/:instId/:type",
      name: "inst",
      component: () => import("@/components/flow/task.vue"),
      props: true
    },
    /* 待阅列表跳转 */
    {
      path: "/inst/:instId/:type/:readId",
      name: "instRead-read",
      component: () => import("@/components/flow/task.vue"),
      props: true
    },
    /* 已阅列表跳转 */
    {
      path: "/inst/:instId/:type/:readType/:readDoneId",
      name: "instRead-done",
      component: () => import("@/components/flow/task.vue"),
      props: true
    },
    /* 我传阅的列表跳转 */
    {
      path: "/myRead/:instId/:readId/:myReadType",
      name: "myRead-type",
      component: () => import("@/components/flow/task.vue"),
      props: true
    },
    {
      path: "/instRead/:instId/:myReadType",
      name: "instRead",
      component: () => import("@/components/flow/task.vue"),
      props: true
    },
    {
      path: "/taskRead/:taskId/:task_state",
      name: "taskRead",
      component: () => import("@/components/flow/task.vue"),
      props: true
    },
    {
      path: "/inst/:instId",
      name: "defaultInst",
      component: () => import("@/components/flow/task.vue"),
      props: true
    },
    {
      path: "/task/:taskId/:leaderId",
      name: "task",
      component: () => import("@/components/flow/task.vue"),
      props: true
    },
    /* 邮箱页面开始 */
    {
      path: "/v-mail",
      component: menuContent,
      children: [
        {
          path: "/",
          name: "mailList-default",
          redirect: "v-mailList"
        },
        {
          path: "v-mailList",
          name: "mailList",
          component: () => import("@/components/mail/mailList.vue")
        },
        {
          path: "v-linkmanList",
          name: "linkmanList",
          component: () => import("@/components/mail/mailLinkmanList.vue")
        },
        {
          path: "v-settingList",
          name: "settingList",
          component: () => import("@/components/mail/mailSettingList.vue")
        }
      ]
    },
    {
      path: "/mail/mailGet/:id",
      name: "mailGet",
      component: () => import("@/components/mail/mailGet.vue"),
      props: true
    },
    {
      path: "/mail/mailAdd",
      name: "mailAdd",
      component: () => import("@/components/mail/mailAdd.vue")
    },
    {
      path: "/mail/mailEdit/:id",
      name: "mailEdit",
      component: () => import("@/components/mail/mailEdit.vue"),
      props: true
    },
    {
      path: "/mail/linkmanEdit/:id",
      name: "mailLinkmanEdit",
      component: () => import("@/components/mail/mailLinkmanEdit.vue"),
      props: true
    },
    {
      path: "/mail/linkmanGet/:id",
      name: "mailLinkmanGet",
      component: () => import("@/components/mail/mailLinkmanGet.vue"),
      props: true
    },
    {
      path: "/mail/settingAdd",
      name: "mailSettingAdd",
      component: () => import("@/components/mail/mailSettingAdd.vue")
    },
    {
      path: "/mail/settingEdit/:id",
      name: "mailSettingEdit",
      component: () => import("@/components/mail/mailSettingEdit.vue"),
      props: true
    },
    {
      path: "/mail/settingGet/:id",
      name: "mailSettingGet",
      component: () => import("@/components/mail/mailSettingGet.vue"),
      props: true
    },
    /* 邮箱页面结束*/

    {
      path: "/v-personal",
      component: menuContent,
      children: [
        {
          path: "/",
          name: "approvalItem-default",
          redirect: "v-myLayout"
        },
        {
          path: "v-myLayout",
          name: "myLayout",
          component: () => import("@/components/myLayout/myLayoutList.vue")
        },
        {
          path: "vnewsList",
          name: "newsList",
          component: () => import("@/components/news/newsList.vue")
        },

        {
          path: "v-approvalItem",
          name: "approvalItemList",
          component: () =>
            import("@/components/approvalItem/approvalItemList.vue")
        },
        {
          path: "commonFlow",
          name: "commonFlow",
          component: () =>
            import("@/components/commonFlow/commonFlowSetting.vue")
        },
        {
          path: "v-agent",
          name: "agentList",
          component: () => import("@/components/agent/agentList.vue")
        },
        {
          path: "v-secretary",
          name: "secretary",
          component: () => import("@/components/secretary/secretaryList.vue")
        },
        {
          path: "v-bpmDeputy",
          name: "bpmDeputy",
          component: () => import("@/components/bpmDeputy/bpmDeputyList.vue")
        },
        {
          path: "groupManager",
          name: "groupManager",
          component: () => import("@/components/uc/groupManagerList.vue")
        }
      ]
    },
    {
      path: "/v-approvalItem",
      name: "approvalItem",
      component: () => import("@/components/approvalItem/approvalItemList.vue"),
      props: true
    },
    {
      path: "/approvalItem/approvalItemEdit/:id",
      name: "approvalItemEdit",
      component: () => import("@/components/approvalItem/approvalItemEdit.vue"),
      props: true
    },
    {
      path: "/approvalItem/approvalItemAdd",
      name: "approvalItemAdd",
      component: () => import("@/components/approvalItem/approvalItemAdd.vue"),
      props: true
    },
    {
      path: "/approvalItem/approvalItemGet/:id",
      name: "approvalItemGet",
      component: () => import("@/components/approvalItem/approvalItemGet.vue"),
      props: true
    },
    {
      path: "/v-agent",
      name: "agent",
      component: () => import("@/components/agent/agentList.vue"),
      props: true
    },
    {
      path: "/agent/agentAdd",
      name: "agentAdd",
      component: () => import("@/components/agent/agentAdd.vue"),
      props: true
    },
    {
      path: "/agent/agentEdit/:id",
      name: "agentEdit",
      component: () => import("@/components/agent/agentEdit.vue"),
      props: true
    },
    {
      path: "/agent/agentGet/:id",
      name: "agentGet",
      component: () => import("@/components/agent/agentGet.vue"),
      props: true
    },
    {
      path: "/secretary/secretaryEdit/:id",
      name: "secretaryEdit",
      component: () => import("@/components/secretary/secretaryEdit.vue"),
      props: true
    },
    {
      path: "v-bpmDeputy",
      name: "bpmDeputyList",
      component: () => import("@/components/bpmDeputy/bpmDeputyList.vue"),
      props: true
    },
    {
      path: "/bpmDeputy/bpmDeputySetting/",
      name: "bpmDeputySetting",
      component: () => import("@/components/bpmDeputy/bpmDeputySetting.vue"),
      props: true
    },
    {
      path: "/bpmDeputy/bpmDeputySetting/:id",
      name: "bpmDeputySetting-id",
      component: () => import("@/components/bpmDeputy/bpmDeputySetting.vue"),
      props: true
    },
    /* 跳转新闻动态列表 */
    {
      path: "/newsList/:type",
      name: "newsList",
      component: () => import("@/components/news/newsList.vue"),
      props: true
    },
    {
      path: "/news/:newsId",
      name: "newsGet",
      component: () => import("@/components/news/newsGet.vue"),
      props: true
    },
    // 预览文件
    {
      path: "/pdf/:src/:fileId",
      name: "pdf",
      component: () => import("@/components/common/pdf.vue"),
      props: true,
      meta: {
        single: true
      }
    },
    {
      path: "/iframeSrc/:iframeSrc/:fileId",
      name: "iframeSrc",
      component: () => import("@/components/common/iframeSrc.vue"),
      props: true,
      meta: {
        single: true
      }
    },
    {
      path: "/previewForm/:formId",
      name: "previewForm",
      component: () => import("@/components/common/previewForm.vue"),
      props: true,
      meta: {
        single: true
      }
    },
    {
      path: "/previewForm/:formId/:single",
      name: "previewForm-single",
      component: () => import("@/components/common/previewForm.vue"),
      props: true,
      meta: {
        single: true
      }
    },
    {
      path: "/previewInstForm/:defId/:instId",
      name: "previewInstForm",
      component: () => import("@/components/common/previewInstForm.vue"),
      props: true,
      meta: {
        single: true
      }
    },
    {
      path: "/QRCodeForm/:templateKey/:action",
      name: "QRCodeForm",
      component: () => import("@/components/dataTemplate/QRCodeForm.vue"),
      props: true,
      meta: {
        single: true
      }
    },
    {
      path: "/statement",
      name: "statement",
      component: Statement,
      children: [
        {
          path: "/",
          name: "template-default",
          redirect: "/statement/draftList"
        },
        {
          path: "draftList",
          name: "templateDraftList",
          component: () =>
            import("@/components/dataTemplate/TemplateDraft.vue"),
          props: true
        },
        {
          path: "/href/template/:alias",
          name: "templateHref",
          component: () => import("@/components/dataTemplate/templateHref.vue"),
          props: true
        },
        {
          path: "template/preview/:templateKey",
          name: "templatePreview",
          component: () =>
            import("@/components/dataTemplate/templatePreview.vue"),
          props: true
        },
        {
          path: "template/preview/:templateKey/:single",
          name: "templatePreview-single",
          component: () =>
            import("@/components/dataTemplate/templatePreview.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "template/preview/:templateKey/:single/:parameterqQuerys",
          name: "templatePreview-singleQuerys",
          component: () =>
            import("@/components/dataTemplate/templatePreview.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "template/preview/:templateKey/:taskType/:defKey/:isJoinFlow",
          component: () =>
            import("@/components/dataTemplate/templatePreview.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "template/form/:templateKey/:action",
          name: "templateForm",
          component: () => import("@/components/dataTemplate/templateForm.vue"),
          props: true
        },
        {
          path: "template/form/:templateKey/:action/:single",
          name: "templateFormSingle",
          component: () => import("@/components/dataTemplate/templateForm.vue"),
          props: true,
          meta: {
            single: true
          }
        },
        {
          path: "querySql/queryView/:sqlAlias/:alias",
          name: "querySqlContent",
          component: () => import("@/components/querySql/querySqlContent.vue"),
          props: true
        },
        {
          path: "querySql/queryView/:sqlAlias/:alias/:single",
          name: "querySql-single",
          component: () => import("@/components/querySql/querySqlContent.vue"),
          props: true,
          meta: {
            single: true
          }
        }
      ]
    },
    {
      path: "/column/preview/:previewAlias",
      name: "columnpreview",
      component: () => import("@/views/ColumnPreview.vue"),
      props: true,
      meta: {
        single: true
      }
    },
    {
      path: "/onlineForm",
      name: "onlineForm",
      component: () => import("@/components/flow/OnlineForm.vue"),
      props: true
    },
    /* 已办结流程 */
    {
      path: "/completeView/:procDefKey",
      name: "completeView",
      component: () => import("@/components/flow/completeView.vue"),
      props: true
    },
    /* 办结流程，只读表单 */
    {
      path: "/doneReadOnly/:instId",
      name: "doneReadOnly",
      component: () => import("@/components/flow/task/doneReadOnly.vue"),
      props: true
    },
    {
      path: "*",
      component: NotFound,
      meta: {
        single: true
      }
    },
    {
      path: "/appCenterFront",
      name: "appCenter",
      component: () => import("@/components/appCenter/AppCenter.vue")
    },
    {
      path: "/appContent/:type/:id/:otherId",
      name: "appContent",
      component: () => import("@/components/appCenter/AppContent.vue"),
      props: true,
      meta: {
        single: true
      }
    }
  ]
});

const createRouter = () =>
  new Router({
    mode: "history",
    routes: []
  });

//重写动态添加路由方法
router.$addRoutes = params => {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; //重置路由规则
  router.addRoutes(params); // 添加路由
};

//动态新增二级路由
router.addList = (path, list) => {
  let isAddPath = false;
  let isChildren = false;
  for (let i = 0; i < list.length; i++) {
    //判断当前点击菜单的路由别名是否存在 router.js 里面
    if (path == list[i].path) {
      //存在
      //动态注册路由
      let index = path.replace("/", "");
      let templatePreview_new = {
        path: "template/preview/:templateKey",
        name: "templatePreview_" + index,
        props: true,
        component: resolve =>
          require(["@/components/dataTemplate/templatePreview.vue"], resolve)
      }; //数据报表
      let templateHref_new = {
        path: "href/template/:alias",
        name: "templateHref_" + index,
        props: true,
        component: resolve =>
          require(["@/components/dataTemplate/templateHref.vue"], resolve)
      }; //URL菜单
      let querySql_new = {
        path: "querySql/queryView/:sqlAlias/:alias",
        name: "querySql_" + index,
        props: true,
        component: resolve =>
          require(["@/components/querySql/querySqlContent.vue"], resolve)
      }; //自定义视图

      let template_new = {
        path: "template/form/:templateKey/:action",
        name: "template_" + index,
        props: true,
        component: resolve =>
          require(["@/components/dataTemplate/templateForm.vue"], resolve)
      }; //数据报表
      let templateSingle_new = {
        path: "template/form/:templateKey/:action/:single",
        name: "templateSingle_" + index,
        props: true,
        component: resolve =>
          require(["@/components/dataTemplate/templateForm.vue"], resolve)
      }; //数据报表
      let templateQuerys_new = {
        path: "template/preview/:templateKey/:single/:parameterqQuerys",
        name: "templateQuerys_" + index,
        props: true,
        component: resolve =>
          require(["@/components/dataTemplate/templatePreview.vue"], resolve)
      }; //数据报表
      if (list[i].children) {
        //判断是否重复添加路由
        for (let j = 0; j < list[i].children.length; j++) {
          let children = list[i].children[j];
          if (children.name == templatePreview_new.name) {
            isAddPath = true; // true ： 重复路由
            break;
          }
        }
        if (!isAddPath) {
          list[i].children.push(templatePreview_new);
          list[i].children.push(templateHref_new);
          list[i].children.push(querySql_new);
          list[i].children.push(template_new);
          list[i].children.push(templateSingle_new);
          list[i].children.push(templateQuerys_new);
          router.$addRoutes(list);
        }
        isChildren = true;
        break;
      } else isChildren = true;
    }
  }
  return isChildren;
};

let registerRouteFresh = true;

router.beforeEach((to, from, next) => {
  if (
    sessionStorage.menu_alias &&
    to.fullPath &&
    to.fullPath.split("/")[1] == "home"
  ) {
    sessionStorage.menu_alias = "";
  }
  if (to.matched.some(record => !record.meta.anonymous)) {
    let ticket = to.query.token;
    if (window.ssoConfig.mode == "cas") {
      ticket = to.query.ticket;
    }
    let password = to.query.password;
    if (password) {
      sessionStorage.setItem("password", password);
    }
    store
      .dispatch("login/validAndCompletedCurrent", ticket, password)
      .then(() => {
        store._vm.$root.$emit("login-completed", to);
        if (registerRouteFresh) {
          if (sessionStorage.menu_alias) {
            let path = "/" + sessionStorage.menu_alias;

            let isChildren = router.addList(path, router.options.routes); //动态新增二级路由
            //当前点击菜单的路由别名不存在 router.js 里面
            if (!isChildren) {
              let alias_new = {
                path: path,
                name: "alias_new",
                component: resolve =>
                  require(["@/views/menuContent.vue"], resolve),
                children: []
              };
              router.options.routes.push(alias_new);
              router.addList(path, router.options.routes); //动态新增二级路由
            }
            if (to.fullPath.indexOf("&token")) {
              const path = to.fullPath.split("&token")[0];
              router.replace({ path });
            } else {
              router.replace({ path: to.path });
            }
          }
          registerRouteFresh = false;
        }
        next();
      })
      .catch(() => {
        store.dispatch("login/logoutAndCleanUp").then(() => {
          if (window.ssoConfig.mode == "cas" && !ticket) {
            let service = window.location.href;
            localStorage.setItem("service", service);
            window.location.href = window.ssoConfig.url + "?service=" + service;
          }

          if (!window.ssoConfig.mode || window.ssoConfig.mode == "jwt") {
            next({
              path: "/login",
              query: {
                redirect: to.fullPath
              }
            });
          }
        });
      });
  } else {
    next();
  }
});

export default router;
